const ENVIRONMENTS = {
  local: "http://192.168.18.51:8880/HolyHeart/presi/admin/src/php/",
  gt: "https://gt.holyheartamritsar.in/admin/php",
  superkids: "https://superkids.holyheartamritsar.in/admin/php",
  holyheart: "https://holyheartamritsar.in/admin/php/",
};

// Change this key to switch all API links in one place.
const ACTIVE_ENV = "holyheart";

const normalizeUrl = (url) => url.replace(/\/+$/, "") + "/";

const FILE_PATH = normalizeUrl(ENVIRONMENTS[ACTIVE_ENV]);

export { ENVIRONMENTS, ACTIVE_ENV, FILE_PATH };
